import { createSlice } from "@reduxjs/toolkit";
import axios from "../axios";
import getConfig from "../config";
import toast from "../hooks/toast";
import { buildApiV3Url, previousDays } from "../shared/Utils";

const { hostnames } = getConfig();
const { docLockerClient } = hostnames;
const [showToast, hideToast] = toast();

const initialState = {
    isLoading: false,
    page: {
        data: [],
        paginate: {
            pageNumber: 0,
            startIndex: -1,
            endIndex: 0,
            rowsPerPage: 0,
            totalRecords: 0,
        },
    },
    formState: {
        toDate: new Date().toISOString().slice(0, 10),
        fromDate: previousDays(30),
    },
    isExportGlobalValidationLoading: false,
    isDialogOpenGlobalValidationExport: false,
};

export const globalValidationReportSlice = createSlice({
    name: "globalValidationReport",
    initialState,
    reducers: {
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setPage: (state, action) => {
            state.page = action.payload;
        },
        setPageToNull: state => {
            state.page = initialState.page;
        },
        setFormState: (state, action) => {
            state.formState = action.payload;
        },
        clearFormState: state => {
            state.formState = initialState.formState;
        },
        setSortColumn: (state, action) => {
            state.sortColumn = action.payload;
        },
        setIsLoadingGlobalValidationExport: (state, action) => {
            state.isExportGlobalValidationLoading = action.payload;
        },
        setIsDialogOpenGlobalValidationExport: (state, action) => {
            state.isDialogOpenGlobalValidationExport = action.payload;
        },
    },
});

export const {
    setIsLoading,
    setFormState,
    clearFormState,
    setIsLoadingGlobalValidationExport,
    setIsDialogOpenGlobalValidationExport,
} = globalValidationReportSlice.actions;

export const selectIsLoading = state => {
    return state.globalValidationReport.isLoading;
};
export const selectFormState = state => {
    return state.globalValidationReport.formState;
};
export const selectIsExportGlobalValidationLoading = state => {
    return state.globalValidationReport.isExportGlobalValidationLoading;
};
export const selectIsDialogOpenGlobalValidationExport = state => {
    return state.globalValidationReport.isDialogOpenGlobalValidationExport;
};

export const postGlobalValidationCountExportAPI = title => async (dispatch, getState) => {
    const { isExportGlobalValidationLoading, formState } = getState().globalValidationReport;
    const { fromDate, toDate } = formState;
    if (isExportGlobalValidationLoading) {
        return;
    }

    dispatch(setIsLoadingGlobalValidationExport(true));
    const response = await axios
        .post(
            buildApiV3Url(`export-global-validation-count-report`),
            {
                title,
                fromDate,
                toDate,
            },
            { withCredentials: true }
        )
        .catch(() => {
            showToast(
                "error",
                "Failed to run the global validation report. Please try again later."
            );
        });
    dispatch(setIsDialogOpenGlobalValidationExport(false));
    dispatch(setIsLoadingGlobalValidationExport(false));

    if (response.status === 200) {
        const baseURL = `https://${docLockerClient}`;
        window.open(`${baseURL}/mylockers/downloads`, "_blank", "noopener,noreferrer");
        showToast(
            "success",
            "We are working on your export. When it's ready, find it in",
            "export-success",
            true,
            "your downloads",
            () => {
                hideToast("export-success");
                window.open(`${baseURL}/mylockers/downloads`, "_blank", "noopener,noreferrer");
            },
            "The time it takes to export data depends on the size of the file and network traffic."
        );
        return;
    }
};

export default globalValidationReportSlice.reducer;
